import { render, staticRenderFns } from "./FlowPage.vue?vue&type=template&id=1a5890de&scoped=true"
import script from "./FlowPage.vue?vue&type=script&lang=js"
export * from "./FlowPage.vue?vue&type=script&lang=js"
import style1 from "./FlowPage.vue?vue&type=style&index=1&id=1a5890de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5890de",
  null
  
)

export default component.exports